// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/transformations_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsTransformationsDatatable } from "./constants";
import type { AppsTransformationsDatatableParams, AppsTransformationsDatatableResult } from "./types";

export const getTransformationsDatatable = reactQueryTableFetcherAdapter(
  appsTransformationsDatatable,
  (
    signal: AbortSignal,
    { query, groupby, limit = 20, start = 0, sortdir, sortby }: AppsTransformationsDatatableParams
  ): Promise<AppsTransformationsDatatableResult> => {
    return fetch(
      "/apps/transformations_datatable",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
